import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, hash, search } = useLocation();

  // 라우터 경로(pathname) 또는 쿼리(search) 변경 시 즉시 스크롤을 최상단으로 이동합니다.
  // useLayoutEffect를 사용해 DOM 변화를 그리기 전에 스크롤 위치를 리셋하여 플리커를 방지합니다.
  useLayoutEffect(() => {
    // If there's a hash in the URL, let the browser's default behavior work
    if (hash) return;

    // 일부 모바일 브라우저(사파리, 크롬)에서는 body와 documentElement가 각각 스크롤 컨테이너가 될 수 있어
    // 둘 모두를 리셋해줍니다. 또한 setTimeout 0으로 한 번 더 호출하여 React가 새 페이지를 그린 뒤에도
    // 스크롤 위치가 보장되도록 합니다.
    const scrollToTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.body.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    };

    scrollToTop();
    // React StrictMode 중복 호출이나 레이아웃 계산 후 스크롤이 덮어써지는 상황을 대비해 한 번 더 호출
    setTimeout(scrollToTop, 0);
  }, [pathname, search, hash]);

  return null; // This component doesn't render anything
}